export default function(list, keyword){
    return list.filter((o) => {
        return (o.number_display.toString().indexOf(keyword) > -1);
    });
}